import * as React from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = React.lazy(() => import('modules/it_management/pages/settings/RootPage'))
const RedirectToLegalEntitiesPage = React.lazy(
  () => import('modules/it_management/pages/settings/RedirectToLegalEntitiesPage')
)
const LegalEntitiesPage = React.lazy(
  () => import('modules/it_management/pages/settings/LegalEntitiesPage')
)
const DocumentTemplatesPage = React.lazy(
  () => import('modules/it_management/pages/settings/DocumentTemplatesPage')
)

const itInventorySettingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.it_inventory.path,
      element: <RootPage />,
      handle: {
        resource: true,
        meta: () => ({
          title: i18n.t('it_management.it_inventory.title'),
          subNavigation: [
            {
              title: i18n.t('it_management.settings.tabs.legal_entities'),
              href: navigation.settings.it_inventory.legalEntities.fullPath(),
              index: true,
            },
            {
              title: i18n.t('it_management.settings.tabs.document_templates'),
              href: navigation.settings.it_inventory.documentTemplates.fullPath(),
            },
          ],
        }),
      },
      children: [
        {
          index: true,
          element: <RedirectToLegalEntitiesPage />,
        },
        {
          path: navigation.settings.it_inventory.legalEntities.path,
          handle: {
            meta: () => ({
              title: i18n.t('it_management.settings.tabs.legal_entities'),
            }),
          },
          element: <LegalEntitiesPage />,
        },
        {
          path: navigation.settings.it_inventory.documentTemplates.path,
          handle: {
            meta: () => ({
              title: i18n.t('it_management.settings.tabs.document_templates'),
            }),
          },
          element: <DocumentTemplatesPage />,
        },
      ],
    },
  ]
}

export default itInventorySettingsRoutes
